import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useGetHitsQuery, useMarkHitsReadMutation } from "../features/api/apiSlice";
import { IconBell, IconSettings } from "./DemoIcons";

// Demo-native notification bell. Same data + socket behavior as the classic
// NotificationBell, rendered in the demo's own icon-button + popover style so it
// matches the rest of the top bar. Deep links land back in /demo.
export default function DemoBell({ socket }) {
  const { data } = useGetHitsQuery();
  const [markRead] = useMarkHitsReadMutation();
  const [open, setOpen] = useState(false);
  const [liveHits, setLiveHits] = useState([]);
  const [liveUnread, setLiveUnread] = useState(0);

  useEffect(() => {
    if (!socket) return undefined;
    const onNotification = (raw) => {
      let hit;
      try { hit = typeof raw === "string" ? JSON.parse(raw) : raw; } catch (e) { return; }
      setLiveHits((prev) => [hit, ...prev].slice(0, 50));
      setLiveUnread((n) => n + 1);
    };
    socket.on("notification", onNotification);
    return () => socket.off("notification", onNotification);
  }, [socket]);

  const fetchedHits = (data && data.hits) || [];
  const fetchedUnread = (data && data.unread) || 0;
  const hits = [...liveHits, ...fetchedHits].slice(0, 50);
  const unread = fetchedUnread + liveUnread;

  const toggle = () => {
    const next = !open;
    setOpen(next);
    if (next && unread > 0) { markRead(); setLiveUnread(0); }
  };

  const describe = (h) => {
    const who = h.alias && h.alias !== "N/A" ? `${h.alias} (${h.rid})` : `RID ${h.rid}`;
    return `${who} on TG ${h.talkgroupNum}`;
  };
  const timeAgo = (ts) => (ts ? new Date(ts).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) : "");
  const callHref = (h) => {
    if (!h.callId) return undefined;
    const ts = h.callTime || h.time || h.createdAt;
    let href = `/demo/${h.shortName}?call-id=${h.callId}`;
    if (ts) href += `&time=${new Date(ts).getTime() + 1}`;
    return href;
  };

  return (
    <div className="demo-pop-wrap">
      <button className={"demo-icon-btn" + (open ? " active" : "")} onClick={toggle} title="Notifications" aria-label="Notifications">
        <IconBell />
        {unread > 0 && <span className="demo-badge">{unread > 99 ? "99+" : unread}</span>}
      </button>
      {open && (
        <>
          <div className="demo-pop-scrim" onClick={() => setOpen(false)} />
          <div className="demo-pop demo-pop-bell" onClick={(e) => e.stopPropagation()}>
            <div className="demo-pop-head">Notifications</div>
            <div className="demo-pop-list">
              {hits.length === 0 ? (
                <div className="demo-pop-empty">No notifications yet</div>
              ) : (
                hits.map((h, i) => {
                  const href = callHref(h);
                  const body = (
                    <>
                      <div className="demo-pop-title">{describe(h)}</div>
                      <div className="demo-pop-meta">
                        {h.shortName}{h.label ? ` · ${h.label}` : ""} · {timeAgo(h.callTime || h.createdAt || h.time)}
                      </div>
                    </>
                  );
                  return href
                    ? <a key={h.id || h._id || i} className="demo-pop-item" href={href}>{body}</a>
                    : <div key={h.id || h._id || i} className="demo-pop-item">{body}</div>;
                })
              )}
            </div>
            <Link className="demo-pop-foot" to="/notifications" onClick={() => setOpen(false)}>
              <IconSettings /> Manage notifications
            </Link>
          </div>
        </>
      )}
    </div>
  );
}
